import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import toastr from 'toastr';
import './styles/global.scss';
import '../node_modules/font-awesome/css/font-awesome.css';
import '../node_modules/toastr/build/toastr.css';
import '../node_modules/animate.css/animate.css'

toastr.options = {
    closeButton: true,
    positionClass: "toast-top-center"
};

export const showToast = function(toastType: string, message: string, title?: string): any {
    return toastr[toastType.toLowerCase()](message, title);
}

export const handleMessages = (messages: Message[]) => {
    if(messages) {
        for(let message of messages){
            showToast(message.msgType, message.content);
        }
        
    }
}
$(function(){
    handleMessages(window.toastrMessages);
    window.toastrMessages = [];
});